export const roleConfig = {
    entityName: 'ADMINISTRATOR.ROLE.TITLE',
    id: 'ID',
    name: 'FORM_FIELD.NAME',
    isSuperAdmin: 'FORM_FIELD.IS_SUPER_ADMIN',
    isAdmin: 'FORM_FIELD.IS_ADMIN',
    permissions: 'ADMINISTRATOR.PERMISSION.PLURAL'
};